import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail, MapPin, MessageCircle } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 448 512" width="18" height="18" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M448 209.9a210.06 210.06 0 0 1-122.77-39.25V349.38A162.55 162.55 0 1 1 185 188.31V278.2a74.62 74.62 0 1 0 52.23 71.18V0l88 0a121.18 121.18 0 0 0 1.86 22.17h0A122.18 122.18 0 0 0 381 102.39a121.43 121.43 0 0 0 67 20.14Z" />
  </svg>
);

const EXPLORE = [
  { to: "/", label: "Home", testid: "footer-link-home" },
  { to: "/services", label: "Services", testid: "footer-link-services" },
  { to: "/#method", label: "Our Approach", testid: "footer-link-approach" },
  { to: "/#work", label: "Case Studies", testid: "footer-link-case-studies" },
  { to: "/about", label: "About", testid: "footer-link-about" },
  { to: "/contact", label: "Contact", testid: "footer-link-contact" },
];

const SOCIALS = [
  { href: "#", label: "Instagram (link coming soon)", testid: "footer-social-instagram", Icon: Instagram },
  { href: "#", label: "LinkedIn (link coming soon)", testid: "footer-social-linkedin", Icon: Linkedin },
  { href: "#", label: "TikTok (link coming soon)", testid: "footer-social-tiktok", Icon: TikTokIcon },
];

const LEGAL = [
  { label: "Legal Notice", testid: "footer-legal-notice", to: "/legal-notice" },
  { label: "Privacy Policy", testid: "footer-privacy-policy", to: "/privacy-policy" },
  { label: "Terms of Sale", testid: "footer-terms-of-sale", to: "/terms-of-sale" },
  { label: "Refund Policy", testid: "footer-refund-policy", to: "/refund-policy" },
  { label: "Cookies", testid: "footer-cookies", to: "/cookies" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-white/5 bg-[#131313]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" data-testid="footer-logo" className="font-anton text-2xl tracking-tight" aria-label="4EMPIRE — home">
              <span className="text-white">4</span>
              <span className="text-empire-red">EMPIRE</span>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-empire-mist">
              A strategic marketing partner for ambitious brands. We combine strategy, creativity
              and execution to build sustainable growth.
            </p>
            <p className="mt-5 font-grotesk text-xs uppercase tracking-[0.25em] text-empire-red">
              Build Your Empire.
            </p>
          </div>

          <nav aria-label="Footer">
            <h3 className="font-grotesk text-xs uppercase tracking-[0.25em] text-white">Explore</h3>
            <ul className="mt-5 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.testid}>
                  <Link
                    to={l.to}
                    data-testid={l.testid}
                    className="text-sm text-empire-mist transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-grotesk text-xs uppercase tracking-[0.25em] text-white">Contact</h3>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a
                  href="mailto:contact@4empire.fr"
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-3 text-empire-mist transition-colors hover:text-white"
                >
                  <Mail size={16} className="text-empire-red" /> contact@4empire.fr
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/351926856052"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="inline-flex items-center gap-3 text-empire-mist transition-colors hover:text-white"
                >
                  <MessageCircle size={16} className="text-empire-red" /> +351 926 856 052
                </a>
              </li>
              <li className="inline-flex items-center gap-3 text-empire-mist">
                <MapPin size={16} className="text-empire-red" />
                <span data-testid="footer-address">Address: to be added</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-grotesk text-xs uppercase tracking-[0.25em] text-white">Follow</h3>
            <div className="mt-5 flex gap-4">
              {SOCIALS.map(({ href, label, testid, Icon }) => (
                <a
                  key={testid}
                  href={href}
                  data-testid={testid}
                  aria-label={label}
                  className="flex h-10 w-10 items-center justify-center border border-white/10 text-empire-mist transition-colors hover:border-empire-red hover:text-empire-red"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-empire-mist">
            © {new Date().getFullYear()} 4EMPIRE. All rights reserved.
          </p>
          <ul className="flex flex-wrap gap-6">
            {LEGAL.map((l) => (
              <li key={l.testid}>
                <Link
                  to={l.to}
                  data-testid={l.testid}
                  className="text-xs text-empire-mist transition-colors hover:text-white"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
